import SalesInvoice from "./SalesInvoice";


const SalesInvoiceConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/salesInvoice',
      element: <SalesInvoice />,
    },
    
  ],
};

export default SalesInvoiceConfig;
